import React from 'react';
import Box from '../Box/Box';
import Icon from '../Icon/Icon';

import TToastClose from './@types/TToastClose';

/**
 * Toast close button
 * It closes automatically after a certain time
 * Therefore aria-hidden is enabled.
 * The close is on the parent to make the touch target larger
 */

const ToastClose = ({ onClose }: TToastClose) => {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      if (onClose) {
        onClose();
      }
    }
  };

  return (
    <Box
      as="div"
      parent="Toast"
      name="close"
      aria-hidden="true"
      tabIndex={-1}
      onClick={onClose}
      onKeyDown={handleKeyDown}
      role="button"
    >
      <Icon name="close_small" />
    </Box>
  );
};

export default ToastClose;
